import { render, staticRenderFns } from "./BasicFields.vue?vue&type=template&id=8391ecb8"
import script from "./BasicFields.vue?vue&type=script&lang=js"
export * from "./BasicFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports